import React, { Component } from 'react';
import FormatText from '../../../../helpers/FormatText';
import './Section.scss';
import './../../../../theme/fontAwesome.scss';
import ChevronUpBold from './../../../../theme/svgs/chevron-up-bold';
import ChevronDownBold from './../../../../theme/svgs/chevron-down-bold';
import SmallArrowRight from '../../../../theme/svgs/arrow-right-small';

export default class MenuSection extends Component<
    {
        // props
        title?: string;
        url?: string;
        subTitle?: string;
        subUrl?: string;
        target?: string;
        handleTitleClick?: (title) => any;
        activeTitle?: string;
    },
    {
        // state
    }
> {
    public handleTitleClick = () => {
        const { title, handleTitleClick } = this.props;
        if (handleTitleClick && title) {
            handleTitleClick(title);
        }
    }

    public render() {
        const { title, url, subTitle, subUrl, target, activeTitle } = this.props;
        const active = title === activeTitle;
        const hasChildren = React.Children.count(this.props.children) > 0;
        return (
            <div className="mobile-page-section">
                {title && hasChildren ? (
                    <div>
                        <button type="button" onClick={this.handleTitleClick} data-analytics={`Branding-Mobile-Navigation-${FormatText(title)}`}>
                            <h2 className={active ? 'active' : ''}>{title}</h2>
                            {active ? <ChevronUpBold /> : <ChevronDownBold />}
                        </button>
                    </div>
                ) : null}
                {title && !hasChildren ? (
                    <div>
                        <a
                            className="mobile-page-section__title"
                            href={url}
                            target={target ? target : undefined}
                            data-analytics={`Branding-Mobile-Navigation-${FormatText(title)}`}
                        >
                            <h2>{title}</h2>
                        </a>
                    </div>
                ) : null}
                {subTitle && subUrl && active ? (
                    <a
                        className="mobile-page-section__subtitle"
                        href={subUrl}
                        target={target ? target : undefined}
                        data-analytics={`Branding-Mobile-Navigation-${FormatText(title)}-${FormatText(subTitle)}`}
                    >
                        {subTitle}
                        <SmallArrowRight />
                    </a>
                ) : null}

                {active && this.props.children}
                <div className="mobile-page-section__border-style" />
            </div>
        );
    }
}
